import { ReactComponent as CompartmentIcon } from './compartment.svg';

export default CompartmentIcon;
